const customer = {
    state() {
        return {
            step: 1,
            stepSimulator: [],
            plansProvider: [],
        };
    },
    actions: {
        changeStep({ commit }, data) {
            commit("CHANGE_STEP", data);
        },
        changeStepSimulator({ commit }, data) {
            commit("CHANGE_STEP_DATA", data);
        },
        changePlansProvider({ commit }, data) {
            commit("CHANGE_PLANS_PROVIDER", data);
        },
    },
    mutations: {
        CHANGE_STEP(state, step) {
            state.step = step;
        },
        CHANGE_STEP_DATA(state, dataChange) {
            state.stepSimulator.push(dataChange);
        },
        CHANGE_PLANS_PROVIDER(state, plansdata) {
            state.plansProvider = plansdata;
        },
    },
    getters: {
        return_step: (state) => {
            return state.step;
        },
        return_step_data: (state) => state.stepSimulator,
        return_plans_provider: (state) => state.plansProvider,
    },
};

export default customer;
